var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckmark1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkmark 1",
    clipPath: "url(#clip0_111_88)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.89 2.34L6.22998 8L5.16998 9.06C5.02947 9.20069 4.83883 9.27982 4.63998 9.28C4.44157 9.27769 4.25171 9.19888 4.10999 9.06L3.04999 8L0.219971 5.17001C0.0810867 5.02829 0.00230401 4.83843 0 4.64001C0.000175052 4.44117 0.0792782 4.2505 0.219971 4.10999L1.28 3.04001C1.42272 2.90389 1.61277 2.82856 1.81 2.82999C1.90784 2.82821 2.00503 2.84588 2.09601 2.88193C2.18698 2.91797 2.26993 2.9717 2.34 3.04001L4.63998 5.35001L9.76999 0.220001C9.91051 0.0793087 10.1011 0.000175052 10.3 0C10.4984 0.00230401 10.6883 0.0811172 10.83 0.220001L11.89 1.28C12.0307 1.42052 12.1098 1.61115 12.11 1.81C12.1077 2.00841 12.0289 2.19828 11.89 2.34Z",
    fill: "#2E8B57"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_111_88"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.11,
    height: 9.28,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark1);
export default __webpack_public_path__ + "static/media/checkmark 1.8af726c8c8a4cd16f65eb82e5666d7e3.svg";
export { ForwardRef as ReactComponent };